export default __webpack_public_path__ + "static/photo_2-c379cc1dec03db1955dee47a2c73585b.jpg";